export const EIGHT_AM_IN_MINUTES = 480;